import React from "react";

const buildAlt = (project) => {
  if (project.thumbnailAlt?.trim()) return project.thumbnailAlt.trim();
  const parts = [project.title, project.categoryLine, project.summaryLine].filter(Boolean);
  return parts.length ? `${parts.join(" — ")} — Skyline VFX visual development` : "Skyline VFX visual development project";
};

const VisualDevCard = ({ project, index = 0, onActivate, className = "" }) => {
  const alt = buildAlt(project);
  const tags = Array.isArray(project.tags) ? project.tags.filter(Boolean) : [];
  const metaLine = [project.categoryLine, project.summaryLine].filter(Boolean).join(" — ");

  const handleActivate = () => {
    if (typeof onActivate === "function") onActivate(project);
  };

  const isPriority = index === 0;

  return (
    <button
      type="button"
      onClick={handleActivate}
      className={[
        "group flex h-full min-h-0 w-full flex-col text-left rounded-none",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-[#ffa94c]/90 focus-visible:ring-offset-2 focus-visible:ring-offset-black",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      aria-label={`${project.title}. ${metaLine || "View project details"}. Case study view coming soon.`}
    >
      <div className="flex h-full min-h-0 w-full flex-col border border-[#25282c] bg-black/40 p-[15px] transition-[border-color] duration-300 group-hover:border-[#ffa94c]/45">
        <div className="relative flex aspect-[4/3] w-full shrink-0 items-center justify-center overflow-hidden bg-[#111]">
          <img
            src={encodeURI(project.thumbnail)}
            alt={alt}
            loading={isPriority ? "eager" : "lazy"}
            decoding="async"
            className="max-h-full max-w-full object-contain transition-opacity duration-300 group-hover:opacity-95"
          />
        </div>

        <div className="mt-4 flex min-h-[5.5rem] flex-1 flex-col space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white">{project.title}</p>
          {metaLine ? (
            <p className="text-sm font-light leading-relaxed text-gray-500">{metaLine}</p>
          ) : null}
          {tags.length > 0 ? (
            <ul className="mt-auto flex flex-wrap gap-2 pt-1">
              {tags.map((tag) => (
                <li
                  key={tag}
                  className="border border-[#25282c] px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.14em] text-gray-500"
                >
                  {tag}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      </div>
    </button>
  );
};

export default VisualDevCard;
